"use client";

import dynamicImport from "next/dynamic";

const ToolPageClient = dynamicImport(() => import("./ToolPageClient"), {
  ssr: false,
});

export default function ToolPage() {
  return <ToolPageClient />;
}
